import { useState } from "react";

import EditMentionModal from "@/containers/EditMentionModal";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { Mention as MentionType } from "@/types/Mention";
import { cx } from "@/utils";
import Typography from "@components/Typography";

import styles from "./Mention.module.css";

const Mention: React.FunctionComponent<{
  mention: MentionType;
  hideActions?: boolean;
  className?: string;
}> = ({ className, mention }) => {
  const { updateMention } = useEpisodes();

  const [editing, setEditing] = useState(false);

  return (
    <>
      <div
        className={cx(
          styles.root,
          "mention",
          { marked: mention.marked_irrelevant_at },
          className
        )}
        data-mention-id={mention.public_id}
      >
        <div>
          <Typography
            data-testid="mention-text-content"
            className="highlight-match"
            component="span"
            dangerouslySetInnerHTML={{ __html: mention?.trimmed_content }}
          />
        </div>
      </div>
      <EditMentionModal
        show={editing}
        onHide={() => setEditing(false)}
        mention={mention}
        updateMention={updateMention}
      />
    </>
  );
};

export default Mention;
